<template>
  <v-row justify="end">
    <v-col cols="12" class="py-0">
      <h3
        role="presentation"
        v-html="header"
        class="text-h3 font-weight-regular text-center mb-2 pb-2"
      />
      <v-row justify="center">
        <v-chip class="pa-2 ma-1 pillWidth justify-center" size="x-large" color="primary">
          <h3 role="presentation" class="text-h2 font-weight-regular mt-1 mr-1">$</h3>
          <h3
            role="presentation"
            class="text-h3 text-right font-weight-medium"
            style="margin-bottom: -3px"
          >
            <slot>
              <span style="font-size: 1.2em" class="text-right">{{ amount }}</span>
            </slot>
          </h3>
        </v-chip>
      </v-row>
      <h3
        role="presentation"
        v-html="footer"
        class="text-h3 font-weight-regular text-center mt-2 mb-4 pt-2"
      />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'GuidancePill',
  props: {
    header: {
      type: String,
      required: true,
    },
    footer: {
      type: String,
      required: true,
    },
    amount: {
      type: [String, Number],
      required: true,
    },
    classString: {
      type: String,
      required: false,
      default: undefined,
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
h3.text-h3 {
  @media only screen and (max-width: 768px) {
    font-size: 16px !important;
    &.font-weight-medium {
      font-size: 14px !important;
    }
  }
  .pill-body {
    @media only screen and (max-width: 768px) {
      padding: 4px 4px 3px 4px !important;
    }
  }
}
.pillWidth {
  width: 160px !important;
}
</style>
